import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import { logoutRequest } from '../../store/actions/AuthActions';
import { fetchSurveyUrl } from '../../store/actions/AssessmentActions';
import { get_image_endpoint } from '../../ImageEndpoint';
import { defaultSurveyUrl } from '../../const';
import styles from './SurveyModal.scss';

const SurveyModal = () => {
  const { assessment_id, interview_id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const iframeRef = useRef(null);
  const surveyWrapperRef = useRef(null);
  const intervalRef = useRef(null);
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const company_details = useSelector(state => state.auth.company_details);
  const testTitle = useSelector(state => state.assessment.testInfo.title);
  const role = useSelector(state => state.interview?.role);
  const surveyUrl = useSelector(state => state.assessment.surveyUrl);
  const submittedBy = useSelector(state => state.assessment.submittedBy);

  useEffect(() => {
    if (company_details.id) {
      sessionStorage.setItem('company_id', company_details.id);
      sessionStorage.setItem('company_alias', company_details.alias);
      sessionStorage.setItem('company_name', company_details.name);
    }
    if (testTitle) {
      sessionStorage.setItem('test_title', testTitle);
    }
    if (role) {
      sessionStorage.setItem('role', role);
    }
    if (submittedBy) {
      sessionStorage.setItem('submitted_by', submittedBy);
    }
  }, [
    company_details.id,
    company_details.alias,
    company_details.name,
    testTitle,
    role,
    submittedBy,
  ]);

  const constructSurveyUrl = fetchedSurveyUrl => {
    const companyId = company_details.id || sessionStorage.getItem('company_id');
    const submittedByValue = submittedBy || sessionStorage.getItem('submitted_by');
    const urlBase = fetchedSurveyUrl || defaultSurveyUrl;
    if (assessment_id && urlBase)
      return `${urlBase}?assessment_id=${assessment_id}&submitted_by=${submittedByValue}&company_id=${companyId}`;
    if (interview_id && urlBase)
      return `${urlBase}?interview_id=${interview_id}&submitted_by=${submittedByValue}&company_id=${companyId}`;
    return '';
  };

  useEffect(() => {
    const handleSurveyUrlFetched = fetchedSurveyUrl => {
      const fullUrl = constructSurveyUrl(fetchedSurveyUrl);
      setUrl(fullUrl);
      setIsLoading(false);
    };

    const fetchUrl = () => {
      if (assessment_id) {
        return dispatch(fetchSurveyUrl('assessment', '', handleSurveyUrlFetched));
      }
      const submittedByValue = submittedBy || sessionStorage.getItem('submitted_by');
      if (interview_id) {
        if (submittedByValue === 'candidate') {
          return dispatch(fetchSurveyUrl('interviewee', '', handleSurveyUrlFetched));
        } else {
          return dispatch(
            fetchSurveyUrl(
              'interviewer',
              role || sessionStorage.getItem('role'),
              handleSurveyUrlFetched,
            ),
          );
        }
      }
    };

    fetchUrl();
  }, [assessment_id, interview_id, submittedBy, role, dispatch]);

  useEffect(() => {
    let loadCount = 0;
    let handleLoad;

    const checkIframe = () => {
      const iframe = iframeRef.current;
      if (iframe) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;

        handleLoad = e => {
          loadCount++;
          if (loadCount > 1) {
            dispatch(logoutRequest());
            if (assessment_id) {
              history.push('/testcomplete');
            }
            if (interview_id) {
              history.push('/interviewcomplete');
            }
          }
          // Focus the survey-wrapper after iframe is loaded
          if (surveyWrapperRef.current) {
            surveyWrapperRef.current.focus();
          }
        };
        iframe.addEventListener('load', handleLoad);
      }
    };

    intervalRef.current = setInterval(checkIframe, 100);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      const iframe = iframeRef.current;
      if (iframe && handleLoad) {
        iframe.removeEventListener('load', handleLoad);
      }
    };
  }, [history, assessment_id, interview_id]);

  // Logo component with mutation observer
  const Logo = () => {
    useEffect(() => {
      const logoElement = document.querySelector(`.${styles['c-logo']}`);
      console.log(logoElement);

      if (logoElement) {
        const observer = new MutationObserver(mutations => {
          console.log('Logo mutations:', mutations);
        });

        observer.observe(logoElement, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });

        return () => observer.disconnect();
      }
    }, []);

    return (
      <div className={styles['c-logo']}>
        <img
          src={get_image_endpoint(
            company_details.alias || sessionStorage.getItem('company_alias'),
            'dark',
          )}
          className={styles['c-logo__image']}
          alt={(company_details.name || 'Company') + ' logo'}
        />
      </div>
    );
  };

  return (
    <div
      className={styles['survey-wrapper']}
      ref={surveyWrapperRef}
      tabIndex={0} // Make the div focusable
      onScroll={e => console.log('Survey wrapper scroll:', e)}
    >
      {/* {(company_details?.alias || sessionStorage.getItem('company_alias')) && <Logo />} */}
      {isLoading && (
        <div className={styles['survey-loading']}>
          <Spin size="large" />
        </div>
      )}
      {url && !isLoading && (
        <iframe
          ref={iframeRef}
          src={url}
          frameborder="0"
          className={styles['survey-frame']}
          allow="geolocation"
        ></iframe>
      )}
    </div>
  );
};

export default SurveyModal;
